// client/src/context/AuthContext.js
// Håndterer innlogging, brukerdata og token for hele React-appen.
// Pakkes rundt hele appen i index.js slik at alle sider har tilgang.

import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user,   setUser]   = useState(null);
  const [family, setFamily] = useState(null);
  const [members, setMembers] = useState([]);
  const [loading, setLoading] = useState(true);

  // Sett opp axios til å sende token automatisk på alle forespørsler
  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    }
  }, []);

  // Sjekk om brukeren allerede er innlogget (ved oppstart)
  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) { setLoading(false); return; }

    axios.get('/api/auth/me')
      .then(res => {
        setUser(res.data.user);
        setFamily(res.data.family);
        setMembers(res.data.members);
      })
      .catch(() => { localStorage.removeItem('token'); })
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const res = await axios.post('/api/auth/login', { email, password });
    const { token, user: u, family: f } = res.data;
    localStorage.setItem('token', token);
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    setUser(u);
    setFamily(f);
    return res.data;
  };

  const register = async (familyName, name, email, password) => {
    const res = await axios.post('/api/auth/register', { familyName, name, email, password });
    const { token, user: u, family: f } = res.data;
    localStorage.setItem('token', token);
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    setUser(u);
    setFamily(f);
    return res.data;
  };

  const logout = () => {
    localStorage.removeItem('token');
    delete axios.defaults.headers.common['Authorization'];
    setUser(null);
    setFamily(null);
    setMembers([]);
  };

  const loginWithToken = async (token) => {
    localStorage.setItem('token', token);
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    const res = await axios.get('/api/auth/me');
    setUser(res.data.user);
    setFamily(res.data.family);
    setMembers(res.data.members);
  };

  const refreshMembers = async () => {
    const res = await axios.get('/api/members');
    setMembers(res.data);
  };

  const refreshUser = async () => {
    try {
      const res = await axios.get('/api/auth/me');
      setUser(res.data.user);
      setFamily(res.data.family);
      setMembers(res.data.members);
    } catch {}
  };

  return (
    <AuthContext.Provider value={{ user, family, members, loading, login, loginWithToken, register, logout, refreshMembers, refreshUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
